var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "aimodal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-card",
          attrs: { role: "document", "aria-label": "Ask prompt UI" }
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog modal-xl",
              attrs: { role: "document" }
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("header", { staticClass: "header" }, [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("ai.ask.title")))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "muted" }, [
                    _vm._v(_vm._s(_vm.$t("ai.ask.headernote")))
                  ])
                ]),
                _vm._v(" "),
                _vm.tags.length && !_vm.showJobAsk
                  ? _c("div", { staticClass: "tags-row" }, [
                      _c("div", { staticClass: "tags-label" }, [
                        _vm._v(_vm._s(_vm.$t("ai.ask.tag")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tags-list" },
                        _vm._l(_vm.tags, function(t, i) {
                          return _c(
                            "button",
                            {
                              key: i,
                              class: [
                                "tag-btn",
                                { selected: _vm.selectedTags.includes(t) }
                              ],
                              attrs: {
                                "aria-pressed": _vm.selectedTags.includes(t)
                              },
                              on: {
                                click: function($event) {
                                  return _vm.toggleTag(t)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t(t)))]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "tags-actions" }, [
                        _vm.selectedTags.length
                          ? _c(
                              "button",
                              {
                                staticClass: "btn-secondary-small",
                                on: { click: _vm.clearTags }
                              },
                              [_vm._v(_vm._s(_vm.$t("ai.ask.clear")))]
                            )
                          : _c("div", { staticClass: "muted small" }, [
                              _vm._v(_vm._s(_vm.$t("ai.ask.pick")))
                            ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.quicks.length
                  ? _c(
                      "div",
                      { staticClass: "quick-list" },
                      _vm._l(_vm.quicks, function(q, i) {
                        return _c(
                          "button",
                          {
                            key: i,
                            staticClass: "quick-btn",
                            attrs: { title: `Quick: ${q}` },
                            on: {
                              click: function($event) {
                                return _vm.useQuick(q)
                              }
                            }
                          },
                          [_vm._v(_vm._s(q))]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.prompt,
                      expression: "prompt"
                    }
                  ],
                  attrs: {
                    placeholder: _vm.$t("ai.ask.promptplaceholder"),
                    "aria-label": "Prompt textarea"
                  },
                  domProps: { value: _vm.prompt },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      if (!$event.ctrlKey) return null
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.prompt = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "controls",
                    staticStyle: { "margin-top": "0.75rem" }
                  },
                  [
                    _vm.jobRequestMode
                      ? _c("label", { staticClass: "toggle-label" }, [
                          _c("span", [_vm._v(_vm._s(_vm.$t("ai.ask.job")))]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.showJobAsk,
                                expression: "showJobAsk"
                              }
                            ],
                            staticClass: "toggle-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.showJobAsk)
                                ? _vm._i(_vm.showJobAsk, null) > -1
                                : _vm.showJobAsk
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.showJobAsk,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showJobAsk = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showJobAsk = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showJobAsk = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "toggle-slider" })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticClass: "small" }, [
                      _vm._v(_vm._s(_vm.$t("ai.ask.modus")) + ":\n        "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.mode,
                              expression: "mode"
                            }
                          ],
                          staticClass: "mode-select",
                          attrs: { "aria-label": "mode-select" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.mode = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "replace" } }, [
                            _vm._v(_vm._s(_vm.$t("ai.ask.mode.replace")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "append" } }, [
                            _vm._v(_vm._s(_vm.$t("ai.ask.mode.insert")))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("label", { staticClass: "small" }, [
                      _vm._v(_vm._s(_vm.$t("ai.ask.modek")) + ":\n        "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.topK,
                              expression: "topK"
                            }
                          ],
                          staticClass: "mode-select",
                          attrs: { "aria-label": "mode-select" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.topK = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "2" } }, [
                            _vm._v(_vm._s(_vm.$t("ai.ask.mode.strict")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "6" } }, [
                            _vm._v(_vm._s(_vm.$t("ai.ask.mode.interpret")))
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn primary",
                          attrs: { disabled: _vm.loading },
                          on: { click: _vm.submit }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.loading
                                  ? _vm.$t("ai.ask.question")
                                  : _vm.$t("ai.ask.question")
                              ) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn secondary",
                          on: { click: _vm.clearAll }
                        },
                        [_vm._v(_vm._s(_vm.$t("ai.ask.clear")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn secondary",
                          attrs: { disabled: !_vm.prompt },
                          on: { click: _vm.copyPrompt }
                        },
                        [_vm._v(_vm._s(_vm.$t("ai.ask.copy")))]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.loading || _vm.response || _vm.error
                  ? _c(
                      "div",
                      { staticClass: "result" },
                      [
                        _vm.loading
                          ? _c("div", { staticClass: "muted" }, [
                              _vm._v("Anfrage in Arbeit…")
                            ])
                          : _vm.error
                          ? _c("div", { staticClass: "errortext" }, [
                              _vm._v(_vm._s(_vm.error))
                            ])
                          : _c("div", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.$t("ai.ask.answer")))
                              ]),
                              _vm._v(" "),
                              _c("pre", {
                                domProps: { innerHTML: _vm._s(_vm.response) }
                              })
                            ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "preview",
                            staticStyle: { "margin-top": "0.75rem" }
                          },
                          [_vm._v(_vm._s(_vm.$t("ai.ask.sources")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.sources, function(s) {
                          return _c(
                            "div",
                            { key: s.documentId, staticClass: "result" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "sources",
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "space-between"
                                  }
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(s.displayName || s.fileName) +
                                        " | P" +
                                        _vm._s(s.start)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("em", [
                                      _vm._v(
                                        _vm._s(_vm.$t("ai.ask.score")) +
                                          ": " +
                                          _vm._s(s.score.toFixed(3))
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(s.snippet))]),
                              _vm._v(" "),
                              _c("div", [
                                s.publicUrl != ""
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-link",
                                        attrs: {
                                          href: s.publicUrl,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("general.download"))
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("footer", { staticClass: "foot muted" }, [
                  _vm._v("\n      " + _vm._s(_vm.$t("ai.ask.tip")) + "\n    ")
                ])
              ])
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }